export const urlapi = 'http://api.vicitelecom.fr';
// export const urlapi = 'http://localhost:4007';
